// eslint-disable-next-line import/no-anonymous-default-export
export default {
    REGISTER:'register',
    VERIFY_PHONE_OTP:'verify-phone-otp',
    PHONE_OTP_TO_FORGOT_PASSWORD:'phoneotp-to-forgotpassword',
    VERIFY_PHONE_OTP_TO_FORGOT_PASSWORD:'verify-phoneotp-to-forgotpassword',
    VERIFY_EMAIL_OTP:'verify-email-otp',
    EMAIL_OTP_TO_FORGOT_PASSWORD:'emailotp-to-forgotpassword',
    VERIFY_EMAIL_OTP_FORGOT_PASSWORD:'verify-emailotp-to-forgotpassword',
    ACTIVATION:'activation',
    LOGIN:'login',
    REFERESH_TOKEN:'refresh_token',
    FORGOT_PASSWORD:'forgotPassword',
    RESET:'reset',
    GET_USER_INFROMATION:'infor',
    GET_ALL_USERS:'getUsersAllInfor',
    LOGOUT:'logout',
    UPDATE_USER:'updateUser',
    UPDATE_ROLE:'update_role',
    DELETE_USER:'delete',
    CREATE_PROFILE: 'create-profile/{1}?role={0}',
    CREATE_JOB_DRAFT: 'jobs-draft',
    CREATE_JOBS: 'jobs',
    CREATE_JOB: 'jobs',
    UPDATE_JOB: 'jobs',
    GET_JOB:'jobs',
    SIMILIAR_JOBS: 'similar_jobs',
    SEARCH_JOB: 'search',
    CREATE_AVAILABILITY: 'create-availability',
    GET_ALL_AVAILABILITY: 'getAllAvailability',
    GET_AVAILABILITY_BY_ID: 'getAvailabilityById',
    UPDATE_AVAILABILITY: 'updateAvailabilityById',
    DELETE_AVAILABILITY: 'deleteAvailabilityById',
    GET_AVAILABILITY_DOCUMENT: 'getAvailabilityByDocumentId',
    APPLY_JOB: 'add_candidate_application',
    GET_APPLIED_JOBS:'applied_jobs',
    ADD_SERVICE: 'add_service',
    GET_ALL_SERVICES: 'all_services',
    GET_SERVICE_BY_ID: 'service',
    UPDATE_SERVICE: 'service',
    DELETE_SERVICE: 'service',
    GET_COACH_SERVICES: 'services',
    GET_PROFILES: 'profiles',
    UPLOAD_IMAGE:"/upload-image",
    LinkIn_Login: "/user/auth/linkedin",
    Google_Login: "/user/auth/google",
    GET_USER_INFO_BY_ID:"getUserInfoById"
}